export const TEXT = {
    BUTTON: 'button',
    CLICK_TO_UPLOAD: 'Click to upload',
    DRAG_AND_DROP: 'or drag and drop',
};